import React, { forwardRef, useEffect, useImperativeHandle, useRef, useState } from "react";
import "./index.scss";
import { Accordion, ButtonGroup, DropdownButton, Modal } from "react-bootstrap";
import { useAuth } from "../../../../../contexts/AuthProvider";
import { useMediaQuery } from "react-responsive";
import { CostFilter, DateRangeFilter, DaysFilter, DestinationFilter, RatingsFilter, SortingFilter, TravellerFilter } from "./FilterOption";

export const FilterBar = forwardRef(({
    filters,
    setFilters,
    filterDefault,
    setCurrentPaginate,
    defaultMaxPrice,
    showFilterModal,
    setShowFilterModal,
    travellerTypes,
    ratingTypes,
    sortingTypes
}, ref) => {
    const isMobile = useMediaQuery({ query: '(max-width: 1200px)' });
    const { currencyData } = useAuth();
    const ratingRef = useRef([]);
    const travellersRef = useRef([]);

    const [filterModalData, setFilterModalData] = useState(filterDefault);

    const defaultPaginate = () => {
        setCurrentPaginate(1);
    }

    // Reset All Filters Fnc
    const resetFilters = () => {
        setFilters(filterDefault);
        setFilterModalData(filterDefault);
        // Reset All Refs
        [ratingRef, travellersRef].forEach(ref => {
            ref.current.forEach(input => input && (input.checked = false));
        });
        defaultPaginate();
    };

    useImperativeHandle(ref, () => ({
        clearAllFiltersFnc() {
            resetFilters();
        },
    }));

    const handleClearFilters = () => {
        setShowFilterModal(false);
        resetFilters();
    }

    const handleApply = () => {
        setFilters(filterModalData);
        setShowFilterModal(false);
    }

    useEffect(() => {
        if (!isMobile) setShowFilterModal(false);
    }, [isMobile]);

    // console.log("filtersData 1==>", filters);
    // console.log("filterModalData 2==>", filterModalData)
    // console.log("isMobile==>", isMobile)

    return !isMobile ? (
        <div className="filter-wrap">
            <DropdownButton
                as={ButtonGroup}
                title={"Destination"}
                variant="none"
                className="destination-drp-bx"
            >
                <DestinationFilter
                    filters={filters}
                    setFilters={setFilters}
                    defaultPaginate={defaultPaginate}
                />
            </DropdownButton>
            <DropdownButton
                as={ButtonGroup}
                title={"Days"}
                variant="none"
                className="days-filter-bx"
            >
                <DaysFilter
                    filters={filters}
                    setFilters={setFilters}
                    defaultPaginate={defaultPaginate}
                />
            </DropdownButton>
            <DropdownButton
                as={ButtonGroup}
                title={"Cost"}
                variant="none"
                className="cost-filter-bx"
            >
                <CostFilter
                    filters={filters}
                    setFilters={setFilters}
                    defaultPaginate={defaultPaginate}
                    currencyData={currencyData}
                    defaultMaxPrice={defaultMaxPrice}
                />
            </DropdownButton>
            <DropdownButton
                as={ButtonGroup}
                title={"Date"}
                variant="none"
                className="date-range-bx"
            >
                <DateRangeFilter
                    filters={filters}
                    setFilters={setFilters}
                    defaultPaginate={defaultPaginate}
                />
            </DropdownButton>
            <DropdownButton
                as={ButtonGroup}
                title={"Ratings"}
                variant="none"
            >
                <RatingsFilter
                    filters={filters}
                    setFilters={setFilters}
                    ratingTypes={ratingTypes}
                    defaultPaginate={defaultPaginate}
                    ratingRef={ratingRef}
                />
            </DropdownButton>
            <DropdownButton
                as={ButtonGroup}
                title={"Travellers"}
                variant="none"
            >
                <TravellerFilter
                    filters={filters}
                    setFilters={setFilters}
                    travellerTypes={travellerTypes}
                    defaultPaginate={defaultPaginate}
                    travellersRef={travellersRef}
                />
            </DropdownButton>
        </div>
    ) : (
        <Modal
            show={showFilterModal}
            onHide={() => setShowFilterModal(false)}
            keyboard={false}
            size="md"
            centered
            className="filters-modal-style"
            scrollable={true}
        >
            <Modal.Header closeButton>
                <Modal.Title>Filters</Modal.Title>
            </Modal.Header>
            <Modal.Body className=''>
                <Accordion defaultActiveKey={["0", "1", "2", "3", "4", "5", "6"]} alwaysOpen>
                    <Accordion.Item eventKey="0">
                        <Accordion.Header>Destination</Accordion.Header>
                        <Accordion.Body>
                            <DestinationFilter
                                filters={filterModalData}
                                setFilters={setFilterModalData}
                                defaultPaginate={defaultPaginate}
                            />
                        </Accordion.Body>
                    </Accordion.Item>
                    <Accordion.Item eventKey="1">
                        <Accordion.Header>Days</Accordion.Header>
                        <Accordion.Body className="overflow-hidden">
                            <DaysFilter
                                filters={filterModalData}
                                setFilters={setFilterModalData}
                                defaultPaginate={defaultPaginate}
                            />
                        </Accordion.Body>
                    </Accordion.Item>
                    <Accordion.Item eventKey="2">
                        <Accordion.Header>Cost</Accordion.Header>
                        <Accordion.Body className="overflow-hidden">
                            <CostFilter
                                filters={filterModalData}
                                setFilters={setFilterModalData}
                                defaultPaginate={defaultPaginate}
                                currencyData={currencyData}
                                defaultMaxPrice={defaultMaxPrice}
                            />
                        </Accordion.Body>
                    </Accordion.Item>
                    <Accordion.Item eventKey="3">
                        <Accordion.Header>Date</Accordion.Header>
                        <Accordion.Body>
                            <DateRangeFilter
                                filters={filterModalData}
                                setFilters={setFilterModalData}
                                defaultPaginate={defaultPaginate}
                            />
                        </Accordion.Body>
                    </Accordion.Item>
                    <Accordion.Item eventKey="4">
                        <Accordion.Header>Ratings</Accordion.Header>
                        <Accordion.Body>
                            <RatingsFilter
                                filters={filterModalData}
                                setFilters={setFilterModalData}
                                ratingTypes={ratingTypes}
                                defaultPaginate={defaultPaginate}
                                ratingRef={ratingRef}
                            />
                        </Accordion.Body>
                    </Accordion.Item>
                    <Accordion.Item eventKey="5">
                        <Accordion.Header>Travellers</Accordion.Header>
                        <Accordion.Body>
                            <TravellerFilter
                                filters={filterModalData}
                                setFilters={setFilterModalData}
                                travellerTypes={travellerTypes}
                                defaultPaginate={defaultPaginate}
                                travellersRef={travellersRef}
                            />
                        </Accordion.Body>
                    </Accordion.Item>
                    <Accordion.Item eventKey="6">
                        <Accordion.Header>Sorting</Accordion.Header>
                        <Accordion.Body>
                            <SortingFilter
                                filters={filterModalData}
                                setFilters={setFilterModalData}
                                sortingTypes={sortingTypes}
                            />
                        </Accordion.Body>
                    </Accordion.Item>
                </Accordion>
            </Modal.Body>
            <Modal.Footer className='justify-content-between'>
                <button className='btn btn-secondary-color btn-border-color' onClick={handleClearFilters}>
                    Clear
                </button>
                <button className='btn btn-primary-color btn-border-color ms-2' onClick={handleApply}>
                    Apply
                </button>
            </Modal.Footer>
        </Modal>
    )
});